module.exports = __webpack_public_path__ + "img/title_text@x.3d7830e6.png";